import styled from 'styled-components';
import theme from '@/data/theme';

const StyledDisableButton = styled.button`
  color: ${theme.colors.primary};
  background-color: ${theme.colors.primaryLight};
  border: none;
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  width: 100%;
  cursor: pointer;
`;

const ModalButtonWrapper = styled.div`
  display: flex;
  gap: inherit;
`;

const StyledDisabledIconWrapper = styled.div`
  border-radius: 50%;
  display: flex;
  padding: 10px 10px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  border: none;
  cursor: pointer;
  align-self: center;
`;
const StyledModalContentWrapper = styled.div`
  font-size: 14px;
`;

const StyledTableNameHighlighter = styled.span`
  color: ${theme.colors.primary};
`;

export {
  StyledDisableButton,
  ModalButtonWrapper,
  StyledDisabledIconWrapper,
  StyledTableNameHighlighter,
  StyledModalContentWrapper,
};
